import { sensor } from "@/store";
import { computed } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";

export default function () {
    const deviceList = computed<Array<AttachedDeviceModel>>(() => {
        return sensor.devices;
    });
    const getDetectorData = (device: Detectors) => {
        const index = deviceList.value.findIndex((value) => {
            return value.attachedDeviceTypeId === device;
        });
        return deviceList.value[index];
    };
    sensor.GetData();
    return {
        getDetectorData,
    };
}
export enum Detectors {
    smoke = 4,
    co = 5,
    heat = 6,
    gas = 7,
    water = 8,
    gateway = 13,
    bilge = 17,
}
